import { AmountMaskVariantType } from '../../../../../../components/amountMask/types/amountMaskVariantType';
import { AmountMaskState } from '../../../../../../components/amountMask/types/state';
import { commonStyles } from '../commonStyles';
export const getRegularStyles = (FOUNDATIONS, FONT, SHADOWS) => {
    return {
        [AmountMaskVariantType.REGULAR]: {
            [AmountMaskState.SHOWN]: {
                ...commonStyles(FOUNDATIONS, FONT, SHADOWS),
            },
            [AmountMaskState.HIDDEN]: {
                ...commonStyles(FOUNDATIONS, FONT, SHADOWS),
            },
        },
    };
};
//# sourceMappingURL=regular.js.map